import { Button, Modal, Form, Row, Col, Select, message } from "antd";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { handleFetchUsers } from "../../../../api/users";
import { handleAssignApprover } from "../../../../api/units";
import { useContext, useEffect } from "react";
import { AuthContext } from "../../../../contexts/AuthContext";

const { Option } = Select;

export default function AssignApprover({
  isVisible,
  setVisible,
  selected,
  type,
}: any) {
  const {setUnit} = useContext(AuthContext)
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isPending } = useMutation({
    mutationFn: handleAssignApprover,
    onSuccess: (data) => {
      setUnit(data)
      message.success("Assigned Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["units"] });
    },
    onError: (error) => {
      message.error(`${error}`);
    },
  });

  const params = `name=`;

  const { data: users } = useQuery({
    queryKey: ["allUsers"],
    queryFn: () => handleFetchUsers({page:"", limit: "", params }),
  });

  const onSubmit = async () => {
    const { user } = await form.getFieldsValue();

    const data = {
      approverId: user,
      type,
    };
    await mutate({ _id: selected?._id, data });
    setVisible(false);
  };

  const userOptions = users?.records?.map((item: any, index: number) => (
    <Option value={item?._id} key={index}>{item?.name}</Option>
  ));
  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {}, [selected]);

  return (
    <Modal
      open={isVisible}
      title={`Assign ${type}`}
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="assignApprover"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
        >
          Assign
        </Button>,
      ]}
    >
      <Form
        id="assignApprover"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="user"
              rules={[
                {
                  required: false,
                  message: "Please select approver",
                },
              ]}
            >
              <Select
                showSearch
                placeholder={`Select ${type}`}
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {userOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
